// A separate function for navigation is used to make it easier to mock in tests
export default function navigateTo(url: string): void {
  window.location.replace(url);
}
